import React, { useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const MessageContainer = styled(motion.section)`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, #ff1493, #ff69b4, #da70d6);
  }
`;

const MessageTitle = styled(motion.h3)`
  font-size: 1.8rem;
  color: #d84079;
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
`;

const MessageParagraph = styled(motion.p)`
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 1.2rem;
  text-align: right;
  color: #555;
`;

const ExpandButton = styled(motion.button)`
  background: linear-gradient(45deg, #ff1493, #ff69b4);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  font-family: 'Vazirmatn', sans-serif;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(255, 105, 180, 0.4);
  }
`;

const HeartAnimatedIcon = styled(motion.span)`
  display: inline-block;
  font-size: 1.2rem;
  margin: 0 5px;
  color: #ff4b8d;
`;

const containerVariants = {
  hidden: { 
    opacity: 0,
    y: 50
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { 
    opacity: 0,
    y: 20 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};

const LoveMessage = () => {
  const [expanded, setExpanded] = useState(false);
  
  return (
    <MessageContainer
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <MessageTitle
        variants={itemVariants}
        animate={{
          scale: [1, 1.03, 1],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        پیام عاشقانه من برای دلآرام
        <HeartAnimatedIcon
          animate={{
            scale: [1, 1.4, 1],
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            repeatType: "reverse"
          }}
        >
          💗
        </HeartAnimatedIcon>
      </MessageTitle>
      
      <MessageParagraph variants={itemVariants}>
        دلآرام عزیزم، می‌دانم که این روزها حالت خوب نیست و درد داری. می‌خواهم بدانی که همیشه کنارت هستم و عشقم به تو بی‌پایان است.
      </MessageParagraph>
      
      <MessageParagraph variants={itemVariants}>
        تو مثل ماه در شب‌های تاریک زندگی من می‌درخشی و با لبخندت دنیای مرا روشن می‌کنی. حتی در روزهایی که درد داری، زیبایی و قدرت تو مرا شگفت‌زده می‌کند.
      </MessageParagraph>
      
      {expanded && (
        <>
          <MessageParagraph
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            دلآرام جان، می‌دانم که این دوره سخت است، اما این هم می‌گذرد. من همیشه دستت را می‌گیرم و با هم از هر سختی عبور می‌کنیم. تو تنها نیستی عزیزم.
          </MessageParagraph>
          
          <MessageParagraph
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            هر بار که به چشمانت نگاه می‌کنم، عشق را می‌بینم. هر بار که لبخندت را می‌بینم، قلبم با شادی می‌تپد. تو معجزه زندگی من هستی و هر روز به خاطر داشتن تو شکرگزارم.
          </MessageParagraph>
          
          <MessageParagraph
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            به زودی کنارت خواهم بود، دستانت را خواهم گرفت و آرامش را به تو هدیه خواهم کرد. دوستت دارم دلآرام، بیشتر از تمام ستاره‌های آسمان.
          </MessageParagraph>
        </>
      )}
      
      <ExpandButton
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? 'نمایش کمتر' : 'نمایش بیشتر'}
      </ExpandButton>
    </MessageContainer>
  );
};

export default LoveMessage; 